/**
 * The visitor's chosen audience (legal professional vs. member of the public),
 * persisted so the splitter at "/" can send a returning visitor straight to the
 * side they picked last time.
 *
 * Shared by AudienceSplitter (which sets it) and Footer (whose quiet switch
 * links have to update it, or the splitter would bounce the visitor back).
 */
export const AUDIENCE_KEY = "lawfusion.audience";

export const AUDIENCES = {
  // The attorney side lands on its own homepage rather than dropping a
  // first-time visitor straight into the workspace — now that the splitter is
  // the site homepage, this is the only route to that page.
  attorney: { label: "Attorney / Paralegal", path: "/attorneys" },
  consumer: { label: "Legal Question", path: "/ask" },
};

export function readAudience() {
  try {
    const saved = localStorage.getItem(AUDIENCE_KEY);
    return AUDIENCES[saved] ? saved : null;
  } catch (e) {
    return null;
  }
}

export function setAudience(key) {
  try {
    localStorage.setItem(AUDIENCE_KEY, key);
  } catch (e) {
    // Private browsing — the choice just won't be remembered.
  }
}

export function clearAudience() {
  try {
    localStorage.removeItem(AUDIENCE_KEY);
  } catch (e) {
    // no-op
  }
}
